import React from 'react';
import styled from 'styled-components';

import {getApiUrl} from '../lib/api';
import Nl2br from './Nl2br';
import {buildCatalogMap} from '../lib/catalog';

function Answer({question, answers, catalog, onImageLoaded = () => {}}) {
  if(!answers || answers.length < 1) {
    return <span>(No answer)</span>;
  }

  switch(question.type) {
    case 'BOOLEAN':
      return <span>{(answers[0].value === "true" || answers[0].value === true) ? 'Yes (True)' : 'No (False)'}</span>;
    case 'SIGNATURE':
    case 'IMAGE': {
      const extension = question.type === 'SIGNATURE' ? 'png' : 'jpg';
      return (
        <a href={`${getApiUrl()}/image/${answers[0].value}.${extension}`} target="_blank" rel="noopener noreferrer">
          <Image
            src={`${getApiUrl()}/image/${answers[0].value}`}
            alt={`${question.text} answer`}
            width="200"
            onLoad={onImageLoaded}
          />
        </a>
      );
    }
    case 'DATETIME': {
      const formattedDate = new Date(parseInt(answers[0].value.split(',')[0], 10)).toLocaleString();
      return <span>{formattedDate}</span>;
    }
    case 'SCANNED_CODE':
    case 'TEXT':
      return <Nl2br>{answers[0].value}</Nl2br>;
    case 'CATALOG_CHECKBOX':
    case 'CATALOG_RADIO': {
      const catalogMap = buildCatalogMap(catalog);
      return <span>{answers.map(answer => answer.value.split(',').map(id => catalogMap[id.trim()] ? catalogMap[id.trim()].name : '(deleted)').join(' → ')).join(', ')}</span>
    }
    default:
      return <span>{answers.sort((a, b) => a.createdDate - b.createdDate).map(answer => answer.value).join(', ')}</span>;
  }
}

const Image = styled.img`
  border-radius: 0.25rem;
  display: block;
`;

export default Answer;
